import { useCallback } from "react";
import { selectMapTypeId, setMapTypeIdAction } from "@store/map/mapReducer";
import { useDispatch } from "react-redux";
import { useAppSelector } from "@store/store";
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import { Text } from "@ui-kit/Text/Text";
import { useTranslation } from "react-i18next";

import "./LayerSelector.css";

const LayerSelector = () => {
  const map = useMap();
  const dispatch = useDispatch();
  const mapTypeId = useAppSelector(selectMapTypeId);
  const { t } = useTranslation();

  useEffect(() => {
    if (!map) {
      return;
    }
    map.setMapTypeId(mapTypeId);
  }, [map, mapTypeId]);

  const handlePress = useCallback(
    (typeId: "roadmap" | "satellite" | "terrain") => {
      dispatch(setMapTypeIdAction(typeId));
    },
    [dispatch],
  );

  return (
    <div className="layer-selector-component">
      <div>
        <button
          onClick={() => handlePress("roadmap")}
          className={mapTypeId === "roadmap" ? "active" : ""}>
          <img src="/images/map/roadmap-map-layer.png" />
        </button>
        <Text variant="fontBodyMedium">{t("map.default")}</Text>
      </div>
      <div>
        <button
          onClick={() => handlePress("satellite")}
          className={mapTypeId === "satellite" ? "active" : ""}>
          <img src="/images/map/satellite-map-layer.png" />
        </button>
        <Text variant="fontBodyMedium">{t("map.satellite")}</Text>
      </div>
      <div>
        <button
          onClick={() => handlePress("terrain")}
          className={mapTypeId === "terrain" ? "active" : ""}>
          <img src="/images/map/terrain-map-layer.png" />
        </button>
        <Text variant="fontBodyMedium">{t("map.terrain")}</Text>
      </div>
    </div>
  );
};

export { LayerSelector };
